import { useCallback, useState } from 'react';
import { useDeleteBooking } from 'src/hooks/queries/booking/useDeleteBooking';
import { useAppState } from 'src/context';
import { formatError } from 'src/utils/helpers/errors';
import { AxiosError } from 'axios';

export const useModalState = (id: string) => {
    const [serverErrors, setServerErrors] = useState<string[]>([]);
    const [message, setMessage] = useState('');

    const {
        actions: { handleCloseModal },
    } = useAppState();

    const { mutateAsync: deleteAsync, isLoading: isDeleting } = useDeleteBooking();

    const onDeleteClick = useCallback(async () => {
        try {
            await deleteAsync({
                id,
                message,
            });
            handleCloseModal();
        } catch (err) {
            setServerErrors(formatError(err as AxiosError<{ message: string }>));
        }
    }, [deleteAsync, message, id, handleCloseModal, setServerErrors]);

    return {
        isDeleting,
        onDeleteClick,
        serverErrors,
        setServerErrors,
        setMessage,
    };
};
